var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yxtbiz-ai-robot__treasure" },
    [
      _c(
        "transition",
        { attrs: { name: _vm.isFullscreen ? "slideLeft" : "slide" } },
        [
          _vm.customVisible
            ? _c("div", { staticClass: "yxtbiz-ai-robot__treasure-small" }, [
                _c(
                  "div",
                  { staticClass: "yxtbiz-ai-robot__treasure-small--header" },
                  [
                    !_vm.isFullscreen
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "yxtbiz-ai-robot__treasure-small--back",
                            on: {
                              click: function ($event) {
                                _vm.customVisible = false
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass:
                                "yxt-icon-arrow-left font-size-24 font-bold",
                            }),
                            _c("span", { staticClass: "ml2" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("pc_comp_pageHeader_title" /** 返回 */)
                                )
                              ),
                            ]),
                          ]
                        )
                      : _c("yxt-svg", {
                          staticClass: "yxtbiz-ai-robot__treasure-small--close",
                          attrs: {
                            "remote-url":
                              _vm.$staticBaseUrl +
                              "ufd/55a3e0/assistent/pc/svg/",
                            width: "20px",
                            height: "20px",
                            "icon-class": "ai-closed",
                          },
                          nativeOn: {
                            click: function ($event) {
                              _vm.customVisible = false
                            },
                          },
                        }),
                    _c("yxt-svg", {
                      attrs: {
                        "remote-url":
                          _vm.$staticBaseUrl + "ufd/55a3e0/assistent/pc/svg/",
                        width: "16px",
                        height: "16px",
                        "icon-class": "treasure_icon",
                      },
                    }),
                    _c(
                      "span",
                      { staticClass: "standard-size-16 yxt-weight-5 ml4" },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("pc_biz_lbl_treasure_chest").d("百宝箱")
                          )
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "yxtbiz-ai-robot__treasure-small--nav" },
                  [
                    _vm.showSearch
                      ? [
                          _c(
                            "div",
                            {
                              staticClass:
                                "yxtbiz-ai-robot__treasure-small--search",
                            },
                            [
                              _c(
                                "yxt-input",
                                {
                                  attrs: {
                                    placeholder: _vm
                                      .$t("pc_biz_msg_placeholder_txt")
                                      .d("请输入内容文字"),
                                    searchNoIcon: "",
                                  },
                                  on: { search: _vm.postTreasureList },
                                  model: {
                                    value: _vm.content,
                                    callback: function ($$v) {
                                      _vm.content =
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                    },
                                    expression: "content",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "yxt-input__icon yxt-icon-search hand",
                                    attrs: { slot: "suffix" },
                                    on: { click: _vm.postTreasureList },
                                    slot: "suffix",
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "yxt-button",
                            {
                              staticClass: "ml12",
                              attrs: { type: "text" },
                              on: { click: _vm.closeSearch },
                            },
                            [_vm._v("取消")]
                          ),
                        ]
                      : [
                          _c(
                            "yxt-tabs",
                            {
                              attrs: { "height-size": "small" },
                              on: { "tab-click": _vm.handleTabsClick },
                              model: {
                                value: _vm.activeTab,
                                callback: function ($$v) {
                                  _vm.activeTab = $$v
                                },
                                expression: "activeTab",
                              },
                            },
                            [
                              _c("yxt-tab-pane", {
                                attrs: {
                                  label: _vm.$t("pc_biz_lbl_winnow").d("精选"),
                                  name: "tab1",
                                },
                              }),
                              _c("yxt-tab-pane", {
                                attrs: {
                                  label: _vm
                                    .$t("pc_biz_lbl_usual")
                                    .d("我的常用"),
                                  name: "tab2",
                                },
                              }),
                            ],
                            1
                          ),
                          _c("yxt-svg", {
                            staticClass: "hand",
                            attrs: {
                              "remote-url":
                                _vm.$staticBaseUrl +
                                "ufd/407a24/assistent/pc/svg/",
                              width: "20px",
                              height: "20px",
                              "icon-class": "search",
                            },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.toSearch.apply(null, arguments)
                              },
                            },
                          }),
                        ],
                  ],
                  2
                ),
                _c(
                  "div",
                  { staticClass: "yxtbiz-ai-robot__treasure-small--body" },
                  [
                    _c(
                      "yxt-scrollbar",
                      {
                        ref: "scrollbar",
                        staticClass: "yxtbiz-ai-robot-scrollbar",
                        attrs: { "fit-height": true },
                      },
                      [
                        _vm.loading
                          ? _c("div", {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.loading,
                                  expression: "loading",
                                },
                              ],
                              staticClass: "pos-center",
                              attrs: {
                                "yxt-loading-background": "transparent",
                              },
                            })
                          : _c("Treasure-list", {
                              attrs: {
                                single: _vm.isFullscreen,
                                list: _vm.list,
                              },
                              on: {
                                toggleCollect: _vm.toggleCollect,
                                operation: _vm.handleOperation,
                              },
                            }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }